<template>
    <s-modal
        :open="open"
        title="Parrainer"
        :close="true"
        @close="$emit('close')"
    >
        
        <div style="width: 100%;text-align:right;margin-bottom: 10px">
             <s-button icon="info" label="Comment et combien je peux gagner de crédits" theme="is-info"
            @onclick="infoParrainage=true"/>
        </div>
        <div style="width: 100%;text-align:right">
            <s-button label="Historique de vos parrainages" icon="history" @onclick="openModalHistorique" theme="is-primary" />
        </div>
        <br/>
        <div class="titleCredit">
            <s-l id="EnvoieParrain">Vous êtes sur le point de parrainer un ami</s-l>
           
        </div>
        <div class="labelSend">
            <s-l id="envoieMailFilleul"> Mail de votre filleul :</s-l>
        </div>
        <s-input type="text" theme="is-large is-primary" v-model="mailUser" placeholder="Mail du filleul" /><br/>
      
         <i style="color:red;font-size:16px" v-show="mailUser==$store.getters.getUser.email">
                    vous ne pouvez pas vous parrainer vous même
                </i>
        <div class="buttonSend">
            <s-button icon="paper-plane" 
                label="Envoyer" 
                theme="is-success is-large" 
                @onclick="goToSendfilleul" 
                :disabled="!validEmail" /><br/>
               
        </div>
        <div class="buttonCancel">
            <s-button icon="undo" label="Annuler" theme="is-warning is-large" @onclick="$emit('close')" />
        </div>
        <waiting :open="openWaiting"/>
        <s-modal :open="openSendParainOk" :close="true" @close="$emit('close')">
            Félicitations ! Dès que votre filleul achètera des crédits ou souscrira un abonnement, vous recevrez des crédits !
        </s-modal>
        <s-modal :open="dejaParraine" :close="true" @close="$emit('close')">
            Oups... Vous avez déjà parrainé cet utilisateur. Cliquez sur historique pour en savoir plus ...
        </s-modal>
        <s-info 
            :open="infoParrainage"
            @close="infoParrainage=false"
            :close="true"
            :big="true">
            <div style="font-size: 16px">
            1 crédit acheté par votre filleul : vous recevez 1 crédit !<br/>
            Si votre filleul souscrit à un abonnement :<br/>
            - Mensuel : vous recevez 2 crédits à chaque renouvellement<br/>
            - Annuel : vous recevez 10 crédits <br/>
            <hr/>
            <i>La limite de crédits est de 10 crédits par filleul !</i>
            </div>
        </s-info>
        <s-modal
            :open="modalHistorique"
            :close="true"
            @close="modalHistorique=false"
            title="Vos parrainages"
        >
            <div v-for="historiqueItem in historiques">
                {{historiqueItem.userToSend}} : {{historiqueItem.credits}} crédits / 10
                
            </div>
           <div v-if="emptyHisto">
               Vous n'avez parrainé personne pour le moment
           </div>
        </s-modal>
    </s-modal>
</template>
<style scoped>
 .labelSend {
        font-size: 14px;
        font-weight: bolder;
        margin-top: 20px;
    }
    .explainMail {
        font-size: 12px;
        font-style: italic;
    }
    .buttonSend {
        float: right;
        margin-top: 10px;
    }
    .buttonCancel {
        float: left;
        margin-top: 10px;
    
    }
    .titleCredit {
        font-size: 14px;
    }
</style>
<script>
import joueur_fct from '@/firebase/joueur'
import firebase from 'firebase/app'
import mail_fct from "@/firebase/mails"
import firebase_api from "@/firebase/firebase_api"
export default {
    props: ["open"],
    watch: {
        open(val) {
            this.mailUser = "";
            this.envoyerCredit= 0;
            this.openSendParainOk=false;

            if (val)
                this.setCreditUser();
        }
    },
    data() {
        return {
            mailUser: "",
            envoyerCredit: 0,
            openWaiting: false,
            openSendOk: false,
            creditUser: 0,
            infoParrainage: false,
            openSendParainOk: false,
            dejaParraine: false,
            modalHistorique: false,
            historiques: {},
            emptyHisto: true
        }
    },
    computed: {
        validEmail: {
            get() {
                if (this.mailUser == this.$store.getters.getUser.email)
                    return false;
                else
                    return joueur_fct.object.verifEmail(this.mailUser);
            }
        }
    },
    methods: {
        openModalHistorique() {
            this.emptyHisto = true;
            firebase_api.api.getDb().collection("user").doc(this.$store.getters.getUser.email).collection("parrainage").where("parrain","==", true)
                .get().then(res=>{
                res.docs.forEach(item=>{
                    var itemData = item.data();
                    this.historiques[itemData.id] = itemData;
                    this.emptyHisto = false;
                })
            })
            this.modalHistorique = true;
        },
        setCreditUser() {
            firebase_api.api.getDb().collection("credit").doc( this.$store.getters.getUser.authId).get().then(credit=>{
                if (!credit.empty) {
                    this.creditUser = credit.data().credit;
                }
            })
        },
        goToSendfilleul() {
           
                
                const functions = firebase.app().functions('europe-west1');
                const params =  {
                    type: "PARRAINAGE",
                    email: this.mailUser,
                    url: window.location
                }
                this.openWaiting = true;
                functions.httpsCallable("sendParrain")(params).then(res=>{
                    
                    if (res) {
                        this.openWaiting = false;
                        this.openSendParainOk = true;
                        var paramsMail= {
                            displayName: this.$store.getters.getUser.displayName,
                            url: window.location.origin
                        }
                        mail_fct.object.sendEmail(this.mailUser, "SEND_PARRAIN", paramsMail);
                    }
                    else
                        this.dejaParraine = true;
                    // on envoie le mail
                    // on dit un message comme quoi c bon
                    // il peut aller les voir dans l'historique
                    // i lpeut les anneuler tant que ca n'a pas été pris
                })
            
        }
    }
}
</script>